import React from 'react';
import { Zap, TrendingUp, TrendingDown, Search, FileText } from 'lucide-react';

const metrics = [
  {
    title: 'AI-hakujen näkyvyys',
    value: '1,247',
    change: '+12%',
    trend: 'up',
    icon: Search,
    color: 'purple',
  },
  {
    title: 'Tekoälyn suositukset',
    value: '45,231',
    change: '+8%',
    trend: 'up',
    icon: TrendingUp,
    color: 'green',
  },
  {
    title: 'Maininnat AI-vastauksissa',
    value: '23',
    change: '-3%',
    trend: 'down',
    icon: FileText,
    color: 'blue',
  },
  {
    title: 'Google AI-yhteenveto',
    value: '156',
    change: '+24%',
    trend: 'up',
    icon: Zap,
    color: 'orange',
  },
];

const colorMap: { [key: string]: string } = {
  purple: 'from-purple-500 to-purple-600 shadow-purple-500/25',
  green: 'from-green-500 to-green-600 shadow-green-500/25',
  blue: 'from-blue-500 to-blue-600 shadow-blue-500/25',
  orange: 'from-orange-500 to-orange-600 shadow-orange-500/25',
};

export default function MetricsGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => {
        const Icon = metric.icon;
        const isPositive = metric.trend === 'up';
        
        return (
          <div
            key={index}
            className="bg-slate-800/50 backdrop-blur-xl rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-300 hover:transform hover:scale-105 group"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 bg-gradient-to-r ${colorMap[metric.color]} rounded-lg flex items-center justify-center shadow-lg`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${
                isPositive ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
              }`}>
                {isPositive ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                <span>{metric.change}</span>
              </div>
            </div>
            
            <div>
              <h3 className="text-slate-400 text-sm font-medium mb-1">{metric.title}</h3>
              <p className="text-3xl font-bold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-slate-300 transition-all duration-300">
                {metric.value}
              </p>
            </div>

            <div className="mt-4 h-1 bg-slate-700/50 rounded-full overflow-hidden">
              <div className={`h-full bg-gradient-to-r ${colorMap[metric.color]} animate-pulse`} style={{ width: '70%' }}></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
